module.exports = __webpack_public_path__ + "static/img/school_index_banner.e21536c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/school_index_banner.png
// module id = kRsL
// module chunks = 34